// extracted by mini-css-extract-plugin
module.exports = {"section":"a10a3f92e9--section--VEcnY"};